import axiosClient from './axiosClient';

export const categoriesApi = {
  list: async (params = {}) => {
    const { data } = await axiosClient.get('/categories', { params });
    return data.data;
  },

  get: async (id) => {
    const { data } = await axiosClient.get(`/categories/${id}`);
    return data.data;
  },

  create: async (payload) => {
    const { data } = await axiosClient.post('/admin/categories', payload);
    return data.data;
  },

  update: async (id, payload) => {
    const { data } = await axiosClient.put(`/admin/categories/${id}`, payload);
    return data.data;
  },

  destroy: async (id) => {
    const { data } = await axiosClient.delete(`/admin/categories/${id}`);
    return data.data;
  },
};